const PopUpScreenTitle = ({
  title,
  setpopUpOpen,
  viewDetails,
  deleteDetails,
  blockDetails,
  unBlockDetails,
}) => {
  return (
    <div>
      <button className="w-full">
        <span
          onClick={() => setpopUpOpen(false)}
          className="text-2xl p-0 m-o block float-right mr-3"
        >
          &times;
        </span>
      </button>
      <div className="text-xl font-medium text-neutral-700 mx-5">
        {viewDetails && `${title} - View`}
        {deleteDetails && `${title} - Delete`}
        {blockDetails && `${title} - Block`}
        {unBlockDetails && `${title} - Unblock`}
      </div>
    </div>
  );
};

export default PopUpScreenTitle;
